<template>
    <div v-show="is_window_show" class="win_bg"></div>
    <div v-show="is_window_show" class="win">
        <div class="btn_win_close" @click="is_window_show = false">[X]</div>
        <div class="win-header">Подтвердить удаление</div>
        <br><br>
        <button  class="aspect_btn"  @click="is_window_show = false" >Отмена</button>
        <button  class="aspect_btn" @click="delete_kcop" >Подтвердить удаление</button>
    </div>
</template>

<script>

export default {
    name: 'Windelete',
    emits: ['get_kcop'],
    data() {
        return {
            is_window_show: false,
            kcop_id: 0,
        }
    },
    methods: {
        delete_kcop() {
            console.log(this.kcop_id)
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/kcop/delete/'+this.kcop_id)
                .then(response => { 
                    loader.hide();
                    console.log(response.data.data)
                    this.is_window_show = false
                    this.$emit('get_kcop')
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        }
    }
}

</script>


<style scoped>
    .win_bg {
        display: block;
        position: fixed;
        width: 100% !important;
        height: 100% !important;
        background: #000000;
        opacity: 0.6;
        z-index: 999;
        left: 0px;
        top: 0px;
    }
    .win {
        display: block;
        width: 300px !important;
        height: 200px !important;
        position: absolute;
        background: #ffffff;
        left: 50%;
        margin-left: -150px;
        top: 150px;
        z-index: 1000;
        border-radius: 7px;
        box-sizing: border-box;
        padding: 15px;
        margin-bottom: 50px !important;
    }
    .win-header {
        font-size: 20px;
    }
    .btn_win_close {
        display: block;
        position: absolute;
        width: 15px;
        height: 15px;
        cursor: pointer;
        right: 15px;
    }
    .btn_win_close:hover {
        color: blue;
    }
    .aspect_btn {
        margin-left: 10px;
    }
</style>